import { VIEW_GENERAL_LOG } from '@/common/permissionConstants';

export default [
    {
        path: 'general-log/:activeDialog?/:activeId?/:activeGroupId?',
        name: 'general-log',
        meta: { hasPermission: VIEW_GENERAL_LOG },
        component: () => import('../views/GeneralLogPage.vue'),
        props: true,
    },
];
